// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3vYoe","legacyBtn":"MutateMid_legacyBtn__3DM0l"};